import React from "react";
import { Link, useHistory } from "react-router-dom";
import Marquee from "react-fast-marquee";

const Partners = ({ images, className }) => {
  const history = useHistory();
  return (
    <div className={`partners__box ${className}`}>
      <div className="container">
        <div className="partners__heading text__heading ta-c reveal-from-top">
          Trusted by data-driven companies
        </div>

        <Marquee gradient={false} pauseOnClick speed={20}>
          {images.map((image) => (
            <img key={image.title} src={image.src} alt={image.title} />
          ))}
        </Marquee>

        <div className="partners__cta reveal-from-bottom">
          <button
            className="button__main button__primary"
            onClick={() => history.push("/onestack-data/sign-up")}
          >
            Get Started
          </button>
          <Link to={"/onestack-data/case-studies"}>
            <button className="button__main">
              Read Case Studies{" "}
              <img
                src={require("../../assets/images/long-arrow-right.svg")}
                alt="right arrow"
              />
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Partners;
